
import { useEffect, useReducer, useState } from "react"
import { AppContext } from "store/context/AppContext"
import { FiltersReducer } from "store/reducers/FiltersReducer"
import { NotificationReducer } from "store/reducers/NotificationReducer"

const SIDEBAR_PREFERENCE_KEY = "SIMO_SIDEBAR_OPEN"

const getInitialSidebarState = (): boolean => {
  if (typeof window === "undefined") return true

  const persistedValue = window.localStorage.getItem(SIDEBAR_PREFERENCE_KEY)
  if (persistedValue === "true") return true
  if (persistedValue === "false") return false

  return window.innerWidth >= 1024
}

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [open_sidebar, set_open_sidebar] = useState(getInitialSidebarState)
  const [open_table_filters, set_open_table_filters] = useState(false)
  const [loading_app, set_loading_app] = useState(false)
  const [breadcrumbs_routes, set_breadcrumbs_routes] = useState<Array<{ name: string; href: string }>>([])
  const [notifications, set_notifications] = useReducer(NotificationReducer, [])
  const [filters_table, set_filters_table] = useReducer(FiltersReducer, [])

  useEffect(() => {
    window.localStorage.setItem(SIDEBAR_PREFERENCE_KEY, String(open_sidebar))
  }, [open_sidebar])

  return (
    <AppContext.Provider
      value={{
        open_sidebar,
        set_open_sidebar,
        loading_app,
        set_loading_app,
        notification: {
          state: notifications,
          dispatch: set_notifications,
        },
        breadcrumbs_routes,
        set_breadcrumbs_routes,
        open_table_filters,
        set_open_table_filters,
        filters_table: {
          state: filters_table,
          dispatch: set_filters_table,
        },
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default AppProvider
